import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const submitPasswordChange = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET_CONFIRMATION,
  ({ password, passwordConfirmation, token, recaptchaResponse }) => ({
    password,
    passwordConfirmation,
    token,
    recaptchaResponse
  })
)

export const submitPasswordResetConfirmationSucceeded = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET_CONFIRMATION_SUCCEEDED
)

export const submitPasswordResetConfirmationFailed = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET_CONFIRMATION_FAILED,
  ({ error }) => ({ error })
)
